import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Modal } from 'antd';

import { ReactComponent as Close } from 'assets/bosta-icons/Close.svg';
import {
  getProductDetails,
  getProofOfReturnedPackagesImages
} from 'services/ops-control';

import { ImageCarousel } from 'components/OpsControl/LostOrders/components/ProofModal/ImageCarousel/ImageCarousel';
import { notify } from 'components/Notify/Notify';
import BRButton from 'components/BRButton/BRButton';

const ProductDetailsModal = ({ close, delivery, ...rest }) => {
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const intl = useIntl();

  const fetchProofImages = async (deliveryId) => {
    setIsLoading(true);
    let productImages = [];
    let returnedPackagesImages = [];

    try {
      const { data } = await getProductDetails(deliveryId);
      productImages = data
        ?.map((item) => {
          if (item?.variantDefaultImage) {
            return item?.variantDefaultImage;
          }
        })
        .filter(Boolean);
    } catch (error) {
      notify(error?.message);
    }

    try {
      const { data } = await getProofOfReturnedPackagesImages(deliveryId);
      returnedPackagesImages = data;
    } catch (error) {
      notify(error?.message);
    }

    setImages([...productImages, ...returnedPackagesImages]);
    setIsLoading(false);
  };

  useEffect(() => {
    if (delivery?._id) {
      fetchProofImages(delivery?._id);
    }
  }, [delivery?._id]);

  return (
    <Modal
      className="br-lost-orders__proof-modal"
      {...rest}
      title={
        <div className="br-lost-orders__proof-modal__title">
          <span>
            {intl.formatMessage({
              id: 'ops_control.lost_orders.product_details_modal.title'
            })}
          </span>
          <BRButton type={'link-gray'} onClick={close} label={<Close />} />
        </div>
      }
      footer={<></>}
      centered
    >
      <div className="br-lost-orders__proof-modal__container">
        <ImageCarousel isLoading={isLoading} images={images} />
      </div>
    </Modal>
  );
};

export default ProductDetailsModal;
